module.exports = __webpack_public_path__ + "mobile/img/img1-618.77146891.png";